/**
 * @format
 * */

import React from 'react';
import ReactDOM from 'react-dom';
import {Button, IconButton} from '@sttark/design-system';

import './modal.sass';

const ModalBody = props => {
    return !props.newestds ? (
        <div className={('modal-body ' + props.className).trim()}>{props.children}</div>
    ) : (
        <div className="card_content-holder">{props.children}</div>
    );
};

const ModalHeader = props => {
    return !props.newestds ? (
        // remove this once DS is established accross the entire site
        <div className="modal-header">{props.children}</div>
    ) : (
        <div className="card_header m-0 tw-flex tw-items-center tw-justify-between border-bottom border-darker">
            <h5 className="header_title font-heading-md m-0">{props.children}</h5>
            <div className="header_icon">
                <IconButton icon="close" secondary onClick={props.onClose} large />
            </div>
        </div>
    );
};

const ModalSubtitle = props => {
    return <h5 className="header_subtitle font-heading-md">{props.children}</h5>;
};

const ModalFooter = props => {
    return !props.newestds ? (
        <div className="modal-footer">{props.children}</div>
    ) : (
        // remove this once DS is stablished accross the entire site
        <div className="modal-footer card_footer tw-flex tw-items-center tw-justify-end border-top border-darker">
            <div className="me-5">
                <Button
                    label={props.secondaryLabel}
                    secondary
                    onClick={props.handleSecondaryClick}
                />
            </div>
            <Button
                label={props.primaryLabel}
                iconRight="NavigateRight"
                primary
                onClick={props.handlePrimaryClick}
            />
        </div>
    );
};

const ModalFooterSticky = props => {
    return <div className="modal-footer modal-footer--sticky">{props.children}</div>;
};

const ModalClose = props => {
    return (
        <div className="close-button-container" onClick={props.onClose} style={{cursor: 'pointer'}}>
            <button tabIndex="-2" type="button" className="close-button__closer" aria-label="Close">
                <span aria-hidden="true">
                    <i className="fa fa-close" />
                </span>
            </button>
        </div>
    );
};

const useModalEffect = () => {
    React.useEffect(() => {
        document.body.style.height = '100%';
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.height = 'auto';
            document.body.style.overflow = 'auto';
        };
    }, []);
};

const ModalDrawerHeader = props => {
    return (
        <div className="header border-bottom tw-p-4 tw-flex tw-items-center tw-justify-between">
            <div className="tw-flex tw-items-center tw-justify-start">
                <button
                    onClick={props.onClose}
                    className="btn btn-lg bg-transparent border-0 tw-p-0 m-0">
                    <i className="fa fa-close drawer_close d-inline-block tw-mr-3"></i>
                </button>

                <h2 className="m-0 -p0 drawer_title">{props.title}</h2>
            </div>
            {props.children}
        </div>
    );
};

const ModalDrawer = props => {
    useModalEffect();
    return ReactDOM.createPortal(
        <div>
            <div className="drawer bg-white px-3">{props.children}</div>
            <div onClick={props.onClose} className="modal-backdrop" />
        </div>,
        document.body
    );
};

export default function Modal(props) {
    props = {
        ...{
            modalDialogClass: 'modal-lg',
            modalDialogStyle: {},
            onClose: () => {},
            newModal: false
        },
        ...props
    };
    useModalEffect();
    if (props.pending) {
        return (
            ReactDOM.createPortal(
                <div className="bs4 bs4-nav bs4-buttons bs4-modal bs4-form bs4-utils bs4-grid bs4-cards bs4-listgroup bs4-inputgroup bs4-badge">
                    <div className="modal-open">
                        <div className="modal d-block" role="dialog">
                            <div
                                className={'modal-dialog ' + props.modalDialogClass}
                                style={props.modalDialogStyle}
                                role="document">
                                <div className="modal-content">
                                    <div className="modal-body">Loading...</div>
                                </div>
                                <a tabIndex="-2" onClick={props.onClose} className="btn">
                                    <i className="fa fa-remove" />
                                </a>
                            </div>
                            <div onClick={props.onClose} className="modal-backdrop" />
                        </div>
                    </div>
                </div>
            ),
            document.body
        );
    } else {
        return ReactDOM.createPortal(
            <>
                {/* This component will go through a reiteration soon. Conditionally render the new types until the new one is fully supported in all pages and the old on ecna be deleted*/}
                {!props.noCard && (
                    <div className="bs4 bs4-nav bs4-buttons bs4-modal bs4-form bs4-utils bs4-grid bs4-cards bs4-listgroup bs4-inputgroup bs4-badge">
                        <div className="modal-open">
                            <div className="modal d-block" role="dialog">
                                <div
                                    className={'modal-dialog ' + props.modalDialogClass}
                                    style={props.modalDialogStyle}
                                    role="document">
                                    <div className="modal-content">{props.children}</div>
                                </div>
                                <div onClick={props.onClose} className="modal-backdrop" />
                            </div>
                        </div>
                    </div>
                )}
                {/* New Modals since version 0.2.0 of DS*/}
                {/* If only the dark background is needed because you want to render a custom card pass the noCard prop */}
                {props.noCard && (
                    <div className="modal-overlay--new">
                        <div className="modal-card--new" style={{maxWidth: props.maxWidth}}>
                            {props.children}
                        </div>
                        <div className="modal-backdrop--new" />
                    </div>
                )}
            </>,
            document.body
        );
    }
}

export {
    ModalBody,
    ModalHeader,
    ModalFooter,
    ModalFooterSticky,
    ModalClose,
    ModalSubtitle,
    ModalDrawer,
    ModalDrawerHeader
};
